import {
  AvatarRootProps,
  HStack,
  Heading,
  HeadingProps,
  Text,
  VStack
} from "@chakra-ui/react"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import type { AvatarUser } from "@pathwright/ux/src/components/avatar/types"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useSpaceContext } from "../../../space/api/context"
import AuthFormFooterBoxLink from "../../components/AuthFormFooterBoxLink"
import useColorModeBranding from "../../utils/useColorModeBranding"

type size = HeadingProps["size"] & AvatarRootProps["size"]

export type SignedInProps = {
  size?: size
  allowSignOut?: boolean
}

const SignedIn = ({ size = "sm", allowSignOut = true }: SignedInProps) => {
  const colorPalette = useColorModeBranding()
  const spContext = useSpaceContext()
  const { user } = spContext
  const { t } = useTranslate()

  return user ? (
    <HStack className="SignedIn" gap={2} w="100%" p="1em 0" pos="relative">
      <UserAvatar size={size} user={user as AvatarUser} />
      <VStack alignItems="flex-start" gap={2} overflow="hidden" mr="auto">
        {/* TODO: use fontFamily="theme.heading" once the parent ChakraProvider uses correct heading theme font */}
        <Heading
          as="h1"
          className="theme-heading theme-heading-bold"
          size={size}
          m={0}
          lineClamp={1}
          maxW="100%"
          color="black"
        >
          {user.full_name}
        </Heading>
        <Text lineClamp={1} maxW="100%">
          {user.email}
        </Text>
      </VStack>
      {allowSignOut && (
        <AuthFormFooterBoxLink
          to="/auth/sign-out"
          m={0}
          display="flex"
          flexShrink={0}
          colorPalette={colorPalette}
        >
          <Pathicon icon="arrow-up-line" transform="rotate(-90deg)" />
          {t("auth.sign_out")}
        </AuthFormFooterBoxLink>
      )}
    </HStack>
  ) : null
}

export default SignedIn
